import { render, staticRenderFns } from "./Episodes.vue?vue&type=template&id=4bdbd480&"
import script from "./Episodes.vue?vue&type=script&lang=js&"
export * from "./Episodes.vue?vue&type=script&lang=js&"
import style0 from "./Episodes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports